import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const ScreenBodyShapeStyles = styled(OnboardingPage)`
  ion-content {
    --overflow: visible;

    &::part(scroll) {
      overflow: visible;
    }
  }
`;
